import { Link } from 'react-router-dom';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const previewImages = [
  {
    id: 1,
    url: 'https://public.readdy.ai/ai/img_res/fc3dfb302914a040556d0b9c13c9d91c.jpg',
    delay: 0,
    className: 'row-span-2',
  },
  {
    id: 2,
    url: 'https://readdy.ai/api/search-image?query=minimalist%20geometric%20tattoo%20on%20wrist%2C%20single%20needle%20fine%20line%2C%20clean%20white%20studio%2C%20macro%20photography%2C%20delicate%20design&width=360&height=240&seq=prev2&orientation=landscape',
    delay: 150,
    className: '',
  },
  {
    id: 3,
    url: 'https://readdy.ai/api/search-image?query=vibrant%20color%20watercolor%20tattoo%20on%20shoulder%2C%20artistic%20floral%20design%2C%20professional%20studio%20lighting%2C%20vivid%20colors&width=360&height=240&seq=prev3&orientation=landscape',
    delay: 300,
    className: '',
  },
];

export default function PortfolioPreview() {
  const { ref, visible } = useScrollAnimation(0.1);

  return (
    <section className="py-16 md:py-36 bg-[#FAFAFA] overflow-hidden" ref={ref}>
      <div className="max-w-[1440px] mx-auto px-5 md:px-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-24 items-center">
          {/* Text */}
          <div
            className="lg:w-1/4 flex-shrink-0 w-full text-center lg:text-left transition-all duration-1000 ease-out"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateX(0)' : 'translateX(-40px)',
            }}
          >
            <p className="text-xs tracking-[0.3em] uppercase text-[#999] mb-4">Gallery</p>
            <h2 className="text-2xl md:text-4xl font-thin text-[#1A1A1A] tracking-tight mb-5">
              Latest<br />Works
            </h2>
            <div className="w-8 h-px bg-[#D1D1D1] mb-6" />
            <p className="text-sm text-[#666] leading-relaxed mb-8">
              각 작품은 고객과의 깊은 대화에서 시작됩니다. 개인의 이야기를 피부 위에 새기는 예술.
            </p>
            <Link
              to="/portfolio"
              className="inline-flex items-center gap-2 text-sm text-[#1A1A1A] tracking-widest uppercase font-medium hover:gap-5 transition-all duration-300 cursor-pointer group"
            >
              View All Portfolio
              <span className="w-6 h-px bg-[#1A1A1A] group-hover:w-10 transition-all duration-300" />
            </Link>
          </div>

          {/* Images Grid */}
          <div className="lg:w-3/4 grid grid-cols-2 gap-4" style={{ gridTemplateRows: 'auto auto' }}>
            {previewImages.map((img) => (
              <div
                key={img.id}
                className={`${img.className} overflow-hidden group cursor-pointer relative transition-all duration-900 ease-out`}
                style={{
                  opacity: visible ? 1 : 0,
                  transform: visible ? 'translateY(0) scale(1)' : 'translateY(40px) scale(0.97)',
                  transitionDelay: `${img.delay + 200}ms`,
                  transitionDuration: '900ms',
                }}
              >
                <img
                  src={img.url}
                  alt={`Portfolio ${img.id}`}
                  className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                  style={{ minHeight: img.className === 'row-span-2' ? '400px' : '190px' }}
                />
                {/* Hover overlay */}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-500" />
                <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-400 ease-out">
                  <div className="w-6 h-px bg-white mb-2" />
                  <p className="text-white text-xs tracking-widest uppercase">View Work</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
